import { SegmentWrapper } from 'ui/indexPages/folders/Folders.styles';
import { Link } from 'ui/links';
import { Label, StyledContainer } from './Styled';
import { NavTemplates24 } from 'ui/icons/aurora/24px/headerNav/NavTemplates24';
import { ChevronRightSmall } from 'ui/icons/navigation/ChevronRightSmall';

interface BreadcrumbsProps {
  templateId: number | null;
  templateName: string | undefined;
  locale: string | null;
}

export const Breadcrumbs = ({ templateId, templateName, locale }: BreadcrumbsProps) => {
  return (
    <StyledContainer data-test="device-preview-breadcrumb-bar">
      <SegmentWrapper data-test="templates-breadcrumb" isRoot>
        <Label>
          <Link href="/templates">
            <NavTemplates24 /> Templates
          </Link>
        </Label>
      </SegmentWrapper>
      {templateName && (
        <SegmentWrapper data-test="template-editor-breadcrumb">
          <ChevronRightSmall />
          <Label>
            <Link
              href={`/templates/editor?templateId=${templateId}${locale && `&locale=${locale}`}`}
            >
              {templateName}
            </Link>
          </Label>
        </SegmentWrapper>
      )}

      <SegmentWrapper data-test="device-preview-breadcrumb">
        <ChevronRightSmall />
        <Label>Device Preview</Label>
      </SegmentWrapper>
    </StyledContainer>
  );
};
